<template>
  <div class="animated fadeIn">
    <div id="custom_backdrop"></div>
    <div class="row pageinfo">
      <b-col cols="4" lg="6">
        <!--Display Trash or Normal Table View
        <h2>Invoices</h2>-->
        <h2 v-show="!trash">Trucking Company Invoices</h2>
        <h2 v-show="trash">Trucking Company Invoices - Trash</h2>
      </b-col>   
      <b-col cols="8" lg="6">
         <b-btn v-if="role !='analyst'" class="pull-right" variant="info" @click="send_notification_click()"><i class="fa fa-send"></i></b-btn>
      </b-col>
    </div>

    <!-- Filters block-->
    <div class="filters pb-2">
      <b-row>
        <b-col order="1" order-md="1" cols="8" sm="6" md="4" lg="2" class="my-1">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <b-form-input v-model="filter" placeholder="Search" />
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </div>
          </div>
        </b-col>
        <b-col order="2" order-md="5" cols="4" sm="6" md="2" lg="2" class="ml-auto my-1">
          <b-button class="pull-right" variant="primary" @click="showNewInvoiceModal()">Add Invoice</b-button>
        </b-col>
      </b-row> 
<!--
      <b-row>
        <b-col v-if="role =='super_admin'" class="my-1" title="Energy Companies" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.energy_company_name" >
            <b-dropdown-item @click="ecFilter('All Energy Companies', 0)">All Energy Companies</b-dropdown-item>
            <b-dropdown-item v-for="energy_company_filter in energy_companies_filter" @click="ecFilter(energy_company_filter.company_name, energy_company_filter.id)">{{energy_company_filter.company_name}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col class="my-1 f4" title="Trucking Companies" sm="6" md="3" lg="2">
            <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="filters_save.trucking_company_name">
              <b-dropdown-item @click="tcFilter('All Trucking Companies', 0)"><h6>All Trucking Companies</h6></b-dropdown-item>
              <b-dropdown-item v-for="trucking_company_filter in trucking_companies_filter" @click="tcFilter(trucking_company_filter.name, trucking_company_filter.id)">{{trucking_company_filter.name}}</b-dropdown-item>
            </b-dropdown>
        </b-col>

        <b-col class="my-1 f9" title="Initial Date" sm="6" md="4" lg="3">
          <b-form-input id="haul_start_datetime" v-model="filter_by.initial_date" @change="iFilter" type="date" ></b-form-input>
        </b-col>
        <b-col class="my-1 lg-3 f10" title="End date" sm="6" md="4" lg="3">
          <b-form-input id="haul_end_datetime" v-model="filter_by.end_date" @change="eFilter" type="date"></b-form-input>
        </b-col>       
        <b-col class="my-1 lg-3 f11 " style=" padding-top: 3px; padding-bottom: 3px;" sm="6" md="4" lg="3">
          <b-button block style="height: 100%;" @click="clearFilters()">Clear</b-button>
        </b-col> 
      </b-row>-->

    </div>

    <!-- Main table block -->
    <div class="card">
      <div class="card-body p-0">
        <!-- Shows when loading data-->
        <b-row v-if="loadingData">
          <b-col cols="12" sm="12" md="12" lg="12">
            <p class="text-center"> <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br> Loading data... </p>
          </b-col>
        </b-row>
        <div v-else class="table-responsive p-0 m-0">
          <b-table 
            class="animated fadeIn" 
            striped 
            bordered
            hover 
            show-empty 
            stacked="md" 
            :items="items" 
            :fields="fields" 
            :current-page="currentPage" 
            :per-page="perPage" 
            @filtered="onFiltered" 
            :filter="filter"
            @row-clicked="rowClicked"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"     
          >

          </b-table> 
        </div>
        <!-- User Interface controls -->
        <div class="table-controls">
          <b-row>
            <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
              <div class="input-group mb-3">
                <div class="input-group-prepend"> </div>
                <b-select :options="pageOptions" v-model="perPage" />
              </div>
            </b-col>
            <b-col lg="10" md="10" sm="12" class="my-1">
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="mt-0 mb-3 pull-right" />
            </b-col>
          </b-row>
        </div>
        <!-- End User Interface controls-->
      </div>
    </div>
    <!-- New Energy Company Modal -->
    <b-modal class="newHaulModal" ref="newInvoiceModal" title="New Invoice" v-model="newEC" hide-header-close no-close-on-backdrop no-close-on-esc>
      <b-row>
        <b-col cols="12">
            <b-form-group v-if="role =='super_admin'" :label-cols="4" horizontal label="Trucking Company" label-for="trucking_company">
                <b-form-select :disabled="newHaul.trucking_company_select.length==0" value-field="id" text-field="trucking_company_name" id="trucking_company" v-model="newHaul.trucking_company_id" :options="newHaul.trucking_company_select" @input="selects_trucking_company()" />
            </b-form-group>
            <b-form-group  :label-cols="4" horizontal label="Energy Company" label-for="energy_company">
                <b-form-select :disabled="newHaul.energy_company_select.length==0" value-field="id" text-field="energy_company_name" id="energy_company" v-model="newHaul.energy_company_id" :options="newHaul.energy_company_select" />
            </b-form-group>
            <b-form-group :label-cols="4" horizontal label="Invoice Ref" label-for="invoice_ref">
                <b-form-input id="invoice_ref" v-model="newHaul.volume"  type="text"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" horizontal label="Cost Code/PO" label-for="cost_code">
                <b-form-input id="cost_code" v-model="newHaul.cost_code"  type="text"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" horizontal label="Date" label-for="date">
              <b-form-input id="date" v-model="newHaul.date" type="date"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" horizontal label="Surcharge %" label-for="surcharge">
								<b-form-input id="surcharge" v-model="newHaul.surcharge" type="text" placeholder="0.00" @keydown.native="myOnlyNumber($event, 'surcharge')" @blur.native="inputBlur('surcharge')"></b-form-input>
						</b-form-group>
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="hideNewInvoiceModal" class="float-left">Cancel</b-btn>
        <b-btn :disabled="savebtn" size="md" variant="primary" @click="save_click()" class="float-right">Save</b-btn>
      </div>
    </b-modal> 
    <!-- End New Energy Company Modal-->
    <b-modal class="newHaulModal" ref="newModal" title="Invoice Notification" v-model="newModal" hide-header-close no-close-on-backdrop no-close-on-esc>
      <b-row>
        <b-col cols="12">
          <b-form-group v-if="role =='super_admin'" :label-cols="4" horizontal label="Trucking Company" label-for="trucking_company">
              <b-form-select :disabled="company_name.length==0" value-field="id" text-field="trucking_company_name" id="trucking_company" v-model="model.trucking_company_id" :options="company_name" @input="selects_trucking_company_1()"> 
                <template slot="first"><option :value="null" disabled>-- select trucking company --</option></template>
          </b-form-select>
          </b-form-group>
          <b-form-group  :label-cols="4" horizontal label="Energy Company" label-for="energy_company">
            <b-form-select :disabled="energy_companies.length==0" value-field="id" text-field="energy_company_name" id="energy_company" v-model="model.energy_company_id" :options="energy_companies">
              <template slot="first"><option :value="null" disabled>-- select energy company --</option></template>
            </b-form-select>
          </b-form-group> 
          <b-form-group  :label-cols="4" horizontal label="Invoice Ref" label-for="inv0">
            <b-form-select :disabled="invoices_filter.length==0" value-field="id" text-field="invoice_ref" id="inv0" v-model="model.invoice_id" :options="invoices_filter">
              <template slot="first"><option :value="null" disabled>-- select invoice ref --</option></template>
            </b-form-select>
          </b-form-group>	

        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="hideNewModal" class="float-left">Cancel</b-btn>
        <b-btn :disabled="sendbtn" size="md" variant="primary" @click="send_click()" class="float-right">Send</b-btn>
      </div>
    </b-modal> 

    <!-- Configure Columns to Display-->

  </div>
</template>

<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  import invoices_service from './invoices_service'
  import moment from 'moment';

  Vue.use(VueSweetalert2)
  
  const items = []
  export default {
    name: 'Invoices',
    created: function() {
      this.getAll()
    },
    data() {
      return {
        loadingData                 : true,
        newEC                       : false,
        energy_company_id           : null,
        items                       : items,
        totalRows                   : items.length,
        fieldsSelected              : 8,
        maxFieldsSelected           : 24,
        tempFields                  : [],
        sortBy                      : 'id',
        sortDesc                    : true,
        fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true
        },{
          key: 'energy_company',
          label: 'Energy Company',
          sortable: true
        }, {
          key: 'trucking_company',
          label: 'Trucking Company',
          sortable: true
        }, {
          key: 'volume',
          label: 'Invoice Ref',
          sortable: false,
        }, {
          key: 'cost_code',
          label: 'Cost Code',
          sortable: false,
        }, {
          key: 'date',
          label: 'Date',
          sortable: false,
        }, {
          key: 'surcharge',
          label: 'Surcharge %',
          sortable: false,
        }],
        currentPage               : 1,
        perPage                   : 25,

        pageOptions               : [25, 50, 100],
        filter                    : null,
		    role                      :'',
		    savebtn                   :true,
        filter_by:{ "initial_date"          :   moment().startOf('week').format('YYYY-MM-DD'), 
                    "end_date"              :   moment().endOf('week').format('YYYY-MM-DD'), 
                    "trucking_company_id"   :   "", 
                    "energy_companies_id"   :   "", 
        },
        filters_save              : {
          energy_companies_id     : 0,
          energy_company_name     : 'All Energy Companies',
          trucking_company_id     : 0,
          trucking_company_name   : 'All Trucking Companies',
          load_location_id        : 0,
          load_name               : 'All Loads',
          fluid_type_id           : 0,
          fluid_type_name         : 'All Fluid Types',
          unload_location_id      : 0,
          unload_name             : 'All Unloads',
          initial_date            : '',
          end_date                : '',
          sortby                  : 'haul_id',
          sortdesc                : false
        },
        newHaul: {
            energy_company_select     : [],
            trucking_company_select   : [],
            energy_company_id         : '',
            trucking_company_id       : '',
            volume                    : '',
            cost_code                 : '',
            date			                : null,
            surcharge                 : '',
        },
        energy_companies_filter     : '',
        trucking_companies_filter   : '',
        trash                       : false,
        dpdt                        : 'Active',
        newModal                    : false,
        model                       : {
            id                  : null,
            energy_company_id   : null, 
            trucking_company_id : null, 
            invoice_id          : null,
            date			          : null,
            surcharge           : null,
        },
        company_name                : [],
        energy_companies            : [],
        invoices_filter             : [],
        sendbtn                     : true,
        surcharge                   : '',
      }
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            }
          })

      }
    },
    methods: {
        activate_custom_backdrop() {
            this.$root.$el.classList.add("custom_backdrop_behavior");
        },
        deactivate_custom_backdrop() {
            this.$root.$el.classList.remove("custom_backdrop_behavior");
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        getAll() {
            this.items = []
            invoices_service.getAll()
            .then(data => {
                if (data.status == 'success') {
                    this.items                          = data.invoices.filter(o => o.status_id == (this.trash ? 2 : 1))
                    this.newHaul.trucking_company_select = data.insert_data.company
                    this.invoices_filter                = data.insert_data.invoice_filter 
                    this.role                           = data.role 
                    this.company_name                   = data.insert_data.company
                    if (this.role === 'trucking_company_admin' || this.role === 'trucking_operational_manager') {                      
                            this.model.energy_company_id  = null
                            let trucking_companies        =  this.company_name
                            if (trucking_companies.length > 0) {
                              this.model.trucking_company_id  = trucking_companies[0].id
                              this.energy_companies           = trucking_companies[0].energy_companies
                            } else {
                                this.model.trucking_company_id= null
                                this.energy_companies         = []
                            }
                    }       
                    if (this.role === 'trucking_company_admin' || this.role === 'trucking_operational_manager') {                      
                      this.newHaul.energy_company_id        = ''
                      let trucking_companies                = this.newHaul.trucking_company_select 
                      if (trucking_companies.length > 0) {
                        this.newHaul.trucking_company_id      = trucking_companies[0].id
                        this.newHaul.energy_company_select    = trucking_companies[0].energy_companies
                      } else {
                        this.newHaul.trucking_company_id      = ''
                        this.newHaul.energy_company_select    = []
                      }
                    }         
                }
                else {
                    this.$swal(data.status, data.message, data.status)
                    this.loadingData = false
                    return
                }
                this.loadingData = false
            })
            .catch(error => {
                Vue.swal('Error', 'Server not response. ' + error, 'error')
                this.loadingData = false
            })
        },
        ecFilter(ec_filter,id) {
          this.filter_by['energy_companies_id'] = id

          if (id==0) {
            this.filter_by['energy_companies_id'] = ''
          }
          this.filters_save.energy_company_name =  ec_filter
          this.filters_save.energy_companies_id = id
          this.getAll()
          //this.saveFilters()
          this.loadingData = true

        },
        tcFilter(tc_filter,id) {
          this.filter_by['trucking_company_id'] = id
          if (id==0) {
            this.filter_by['trucking_company_id'] = ''
          }
          this.filters_save.trucking_company_name =  tc_filter
          this.filters_save.trucking_company_id = id
          this.getAll()
          //this.saveFilters()
          this.loadingData = true
        },
        iFilter(a) {
          if (this.filter_by['end_date']=='' || !this.filter_by['end_date']) {
            this.filter_by['end_date'] = ''
            this.filters_save.end_date = ''
          }
          this.filter_by.initial_date = a
          this.filters_save.initial_date = this.filter_by.initial_date
          this.getAll()
          //this.saveFilters()
          this.loadingData = true
        },
        eFilter(a) {
          if (this.filter_by['initial_date'] =='' || !this.filter_by['initial_date']) {
            this.filter_by['initial_date'] = ''
            //this.filters_save.initial_date = ''
          }
          this.filter_by.end_date = a
          //this.filters_save.end_date = this.filter_by.end_date
          this.getAll()
          //this.saveFilters()
          this.loadingData = true
        },
        clearFilters() {
            this.filter_by = {  "initial_date"          : moment().startOf('week').format('YYYY-MM-DD'), 
                                "end_date"              : moment().endOf('week').format('YYYY-MM-DD'), 
                                'energy_companies_id'   : '',
                                "trucking_company_id"   : "", 
                                "load_location_id"      : "",
                                "unload_location_id"    : "",                         
                                'fluid_type_id'         : '',
            }
            this.filters_save = {
              energy_companies_id   : 0,
              energy_company_name   : 'All Energy Companies',
              trucking_company_id   : 0,
              trucking_company_name : 'All Trucking Companies',
              load_location_id      : 0,
              load_name             : 'All Loads',
              unload_location_id    : 0,
              unload_name           : 'All Unloads',
              fluid_type_id         : 0,
              fluid_type_name       : 'All Fluid Types',
              initial_date          : '', // moment().startOf('month').format('YYYY-MM-DD'),
              end_date              : '', //moment().endOf('month').format('YYYY-MM-DD'),
            }
            this.getAll()
            this.loadingData = true
        },
        hideNewInvoiceModal() {
            this.$refs.newInvoiceModal.hide()
        },
        showNewInvoiceModal() {
            this.savebtn=false      
            if (this.role=="super_admin") {
              this.newHaul.trucking_company_id      = ''
              this.newHaul.energy_company_select    = []
            }
            this.newHaul.volume                     = ''
            this.newHaul.cost_code                  = ''
            this.newHaul.date                       = null
            this.newHaul.surcharge                  = ''
            this.newEC = true
        },
        okToSave() {

          if (this.role=="super_admin") {
            if (this.newHaul.trucking_company_id === undefined || this.newHaul.trucking_company_id.length == 0) {
              this.$swal('Alert!', 'Trucking Company not selected', 'warning')
              return false
            }
          }

          if (this.newHaul.energy_company_id === undefined || this.newHaul.energy_company_id.length == 0) {
            this.$swal('Alert!', 'Energy Company not selected', 'warning')
            return false
          } else if (this.newHaul.volume === undefined || this.newHaul.volume.length == 0) {
            this.$swal('Alert!', 'Invoice Ref can not be empty', 'warning')
            return false
          } else if (this.newHaul.cost_code === undefined || this.newHaul.cost_code.length == 0) {
            this.$swal('Alert!', 'Cost Code can not be empty', 'warning')
            return false
          }  else		if(this.newHaul.date === undefined || this.newHaul.date == null) {
						this.$swal('Alert!', 'Date not selected', 'warning')
						return false
          } else if (this.newHaul.surcharge === undefined || this.newHaul.surcharge.length == 0) {
            this.$swal('Alert!', 'Surcharge value can not be empty', 'warning')
            return false
          }
          return true
        },
        save_click() {       
          if (!this.okToSave()) {
            return
          }
          this.savebtn=true
          let saveData = {
            "energy_company_id"   : String(this.newHaul.energy_company_id),
            "trucking_company_id" : String(this.newHaul.trucking_company_id),
            "volume"              : String(this.newHaul.volume),  
            "cost_code"           : String(this.newHaul.cost_code),  
            "date"                : this.newHaul.date,
            "surcharge"          : String(this.newHaul.surcharge),  
          }
          invoices_service.save(saveData)
          .then(data => {
            Vue.swal(data[0], data[1], data[0])
              .then((result) => {
                if (data[0] == 'success') {
                  this.newEC = false
                  this.getAll()
                }
              })
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
          })
          this.savebtn=false
        },
        selects_energy_company() {
          //if (this.role =='super_admin') {
            //let energy_companies                    =  this.newHaul.energy_company_select
            //this.newHaul.trucking_company_select    = []
            //this.newHaul.trucking_company_id        = ''
            //let energy_company_index = energy_companies.map(o => o.id).indexOf(this.newHaul.energy_companies_id)
            
            //if (energy_company_index > -1) {
              //this.newHaul.trucking_company_select = energy_companies[energy_company_index].trucking_companies
           // }
          //}
        },
        selects_trucking_company() {
          let trucking_companies                =  this.newHaul.trucking_company_select
          this.newHaul.energy_company_select    = []
          this.newHaul.energy_company_id        = ''
          if (trucking_companies.length > 0) {
            let trucking_company_index = trucking_companies.map(o => o.id).indexOf(this.newHaul.trucking_company_id)
            if (trucking_company_index > -1) {
              this.newHaul.energy_company_select = trucking_companies[trucking_company_index].energy_companies
            }
          }
        },
        rowClicked(row) {
	        if(!this.trash) {
			      this.$router.push('/invoice/' + row.id + "/")
		      } else {
			      this.restoreTerminal(row.id)
		      }
        },
        trashTerminal() {
				  this.trash = !this.trash
				  this.dpdt = this.trash ? "Trash" : "Active"
				  this.getAll()
				  this.loadingData = true
        },
        restoreTerminal(id) {
          this.$swal({
            title: 'Please, confirm',
            text: "Are you sure to restore this invoice ?",
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
                      reverseButtons: true
          }).then((result) => {
            if (result.value) {
              invoices_service.restore(id)
                .then(data => {
                  this.$swal(data.status, data.message, data.status)
                  if (data.message == 'success') {
                    this.filter = ''
                    this.trash = false
                    this.getAll()
                    this.loadingData = true
                  }
                })
                .catch(error => {
                  this.$swal('Error', 'Server not response. ' + error, 'error')
                })
            }
          })
        },
        send_notification_click() {
          this.sendbtn                    = false 
          this.model.energy_company_id    = null        
          this.model.invoice_id           = null
          this.newModal                   = true
          if (this.role ==='super_admin') {
              this.model.trucking_company_id  = null
          }
        },
        send_click() {
          if (!this.okToSend()) {
              return
          }
          invoices_service.send_invoice(this.model)
            .then(data => {
              if (data.status == 'success') {
                this.$swal(data.status, data.message, data.status)
              }
              else {
                this.$swal(data.status, data.message, data.status)
                return
              }
            })
            .catch(error => {
              Vue.swal('Error', 'Server not response. ' + error, 'error')
            })
          this.sendbtn  = true
          this.newModal = false
        },
        selects_trucking_company_1() {
            let trucking_companies                =  this.company_name
            this.energy_companies                 = []
            this.model.energy_company_id          = null
            if (trucking_companies.length > 0) {
              let trucking_company_index = trucking_companies.map(o => o.id).indexOf(this.model.trucking_company_id)
              if (trucking_company_index > -1) {
                this.energy_companies = trucking_companies[trucking_company_index].energy_companies
              }
            }
        },
        hideNewModal() {
            this.$refs.newModal.hide()
        },
        okToSend() {
          if (this.model.trucking_company_id === undefined || this.model.trucking_company_id===null) {
              this.$swal('Alert!', 'Trucking Company not selected', 'warning')
              return false
          } else if (this.model.energy_company_id === undefined || this.model.energy_company_id===null) {
              this.$swal('Alert!', 'Energy Company not selected', 'warning')
              return false
          } else if (this.model.invoice_id === undefined || this.model.invoice_id == null) {
              this.$swal('Alert!', 'Invoice Ref not selected', 'warning')
              return false
          }   
          return true
        },
        inputBlur(variableName) {
          let variableValue = this.newHaul[variableName]
          if (variableValue.length == 0) {
            this.newHaul[variableName] = "0.00"
          } else {
            let tempValue = variableValue.split(".")
            if (tempValue.length == 1) {
              this.newHaul[variableName] = String(variableValue) + ".00"
            } else if (tempValue.length == 2) {
              this.newHaul[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2)
            }
          }
        },
        myOnlyNumber(evt, variableName) {
          let dotPosition = this.newHaul[variableName].indexOf(".")
          let hasDot = dotPosition > -1
          let length = this.newHaul[variableName].length
          this.isNumber(evt, hasDot, dotPosition, length)
        },
        isNumber: function(evt, hasDot, dotPosition, length) {

          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
            let selectionStart = evt.target.selectionStart;
            let selectionEnd = evt.target.selectionEnd;
            if ((hasDot && (selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart) && length - 2 > dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
              evt.preventDefault();
            } else {
              return true
            }
          } else {
            evt.preventDefault();
          }
        },
  }
}
</script>

<style lang="scss" scoped>
  .show-details-cell{
    font-weight: 500;
    cursor: pointer;
  }
  .table-controls{
    padding: 14px 16px 0 16px;
  }
  /deep/ .table{
    margin: 0;
    td{
      white-space: nowrap;
      vertical-align: middle;
    }
    th{
      white-space: nowrap;
      vertical-align: middle;
    }
    td> div{
      line-height: 1;
    }
    .b-table-details> td {
      background-color: #FFFDF0;
    }
    .b-table-details h6{
      padding: 0;
      margin: 0;
      font-size: 0.8rem;
      line-height: 16px;
      margin-bottom: 8px;
      color: #676973;
    }
    .b-table-details p{
      font-size: 16px;
      color: #3A3E4D;
      padding: 0;
      margin: 0;
      line-height: 18px;
      margin-bottom: 16px;
    }
    .details-container{
      position: relative;
      white-space: normal; 
      display: flex; 
      flex-direction: row;
      flex-wrap: nowrap; 
      justify-content: flex-start;
      .item{
        padding-left: 10px;
        padding-right: 10px;
      }
      .item.location{
        width: 180px;
      }
      .item.ticket{
        width: 130px;
      }
      .item.date{
        width: 180px;
      }
      .item.volume{
        min-width: 100px;
      }
      &::after{
        content: '';
        position: absolute;
        top: 17px;
        left: 0;
        width: 20px;
        height: 100%;
        border-top: 1px solid #bcbcbc;
      }
      &::before{
        content: '';
        position: absolute;
        top: 17px;
        left: 0;
        width: 2px;
        height: 100%;
        border-left: 1px solid #bcbcbc;
      }
    }
    .details-container:last-child::before{
      display: none;
    }
  }
  /deep/ .btn-secondary{
    background: #ffffff;
  }
  /deep/ .custom-control {
    margin: 0;
    padding-left: 1rem;
  }
  /deep/ .select_column{width: 2%}
  /deep/ .bulk-action-controls{
    .dropdown{
      display: block;
      width: 100%;
    }
    .dropdown-toggle{
      display: block;
      width: 100%;
      text-align: left;
    }
    .dropdown-toggle::after {
      position: absolute;
      right: 15px;
      top: 50%;
      margin-top: -2px;
    }
    .close-controls{
      font-size: 18px; 
      font-weight: bold;
      height: 35px; 
      line-height: 14px;
      cursor: pointer;
      padding: 8px;
    }
    .btn-secondary{
      border-color: #cacaca;
    }
    .btn-select{
      height: 35px;
      margin-bottom: auto;
      margin-top: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/invoices/invoices.vue